export default __webpack_public_path__ + "static/flag-round-lat-0a8b8295d249f96964258c5b0dbff167.svg";